import { useCallback, useState, useRef } from 'react';
import { useResizeObserver } from '@wojtekmaj/react-hooks';
import { pdfjs, Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { FaSearchPlus, FaSearchMinus, FaArrowAltCircleRight, FaArrowAltCircleLeft } from "react-icons/fa";

import './Sample.css';

import type { PDFDocumentProxy } from 'pdfjs-dist';

const options = {
  cMapUrl: '/cmaps/',
  standardFontDataUrl: '/standard_fonts/',
};

const resizeObserverOptions = {};

const maxWidth = 1200;

type PDFFile = string | File | null;

function Sample({ file }) {
  const [numPages, setNumPages] = useState();
  const [containerRef, setContainerRef] = useState(null);
  const [containerWidth, setContainerWidth] = useState();
  const [page, setPage] = useState(1);
  const [scale, setScale] = useState(1.00)
  const [height, setHeight] = useState(0)
  const divRef = useRef(null)
  const onResize = useCallback((entries) => {
    const [entry] = entries;

    if (entry) {
      setContainerWidth(entry.contentRect.width);
    }
  }, []);

  useResizeObserver(containerRef, resizeObserverOptions, onResize);

  async function onDocumentLoadSuccess(pdf) {
    console.log(pdf)
    console.log(Object.getOwnPropertyNames(pdf))
    console.log(pdf.getPage)
    console.log(await pdf?.getPage(1))
    console.log(pdf?.numPages)
    setNumPages(pdf?.numPages);
    const pageObj = await pdf.getPage(1);
    const pageHeight = pageObj.view[3]
    console.log(pageHeight)
    setHeight(pageHeight)
  }
  const Next = () => {

    if (page < numPages) {

      setPage(page + 1)

      document.getElementById('scroll').scrollTo(0, (height+ 240) * page )
    } else {
      setPage(1)
      document.getElementById('scroll').scrollTo(0, 0)
    }


  }
  const Back = () => {
    if (page > 1) {
      setPage(page - 1)
      console.log(height * page)
      document.getElementById('scroll').scrollTo(0, (height * (page - 1)))

    } else {
      setPage(numPages)
      document.getElementById('scroll').scrollTo(0, (height * (page - 1)))
    }

  }
  const Zoom = (checker) => {
    if (checker == false) {
      setScale(scale - 0.1)
    } else {
      if (scale < 1.4) {
        setScale(scale + 0.1)
      }

    }
  }


  return (
    <div className="Example" ref={divRef} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div className="Example__container" style={{ height: '100%', width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
        <div className="Example__container__document" ref={setContainerRef} style={{ height: '100%', width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
          <div className='box'>

            <div className='one'>
              <button className='button button-dark float-left' onClick={() => { Zoom(true) }}><FaSearchPlus /></button>
              <button className='button button-clear float-left' onClick={() => { Zoom(false) }}><FaSearchMinus /></button>



            </div>

            <div className='one'>

              <button className='button button-dark float-right' onClick={Next}><FaArrowAltCircleRight /></button>
              <small className='float-right p'>{numPages} Pages</small>
            </div>
          </div>
          <div className='scroll' id="scroll" style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>

            <Document file={file} onLoadSuccess={onDocumentLoadSuccess} options={options}>

              {
                [...Array(numPages).keys()].map(item => (
                  <Page
                    key={`page_${item}+1`}
                    pageNumber={item + 1}
                    width={containerWidth}
                    scale={scale}
                  />
                ))
              }

            </Document>
          </div>

        </div>
      </div>
    </div>
  );
}
export default Sample;
